export default __webpack_public_path__ + "static/media/Reverbnation.1804d2cc.png";